
export const PermissionRouteMap = {
  "sub_menu": {
    "contacts_contacts": '/main/contacts/contact_list',
    "contacts_files": '/main/contacts/files',
    "contacts_groups": '/main/contacts/groups',
    "booking_artists": '/main/booking/artists',
    "booking_booking_list": '/main/booking/booking_list',
    "booking_calendar": '/main/booking/calendar',
    "booking_current_user_tasks": '/main/booking/current_user_tasks',
    "booking_plugins": '/main/booking/plugins',
    "booking_promoters": '/main/booking/promoters',
    "booking_reports": '/main/booking/reports',
    "booking_Requests": '/main/booking/requests',
    "booking_templates": '/main/booking/templates',
    "booking_tours": '/main/booking/tours',
    "booking_venues": '/main/booking/venues',
    "accounting_costs": '/main/accounting/costs',
    "accounting_invoice_reminder": '/main/accounting/invoice_reminders',
    "accounting_invoices": '/main/accounting/invoices',
    "accounting_plugins": '/main/accounting/plugins',
    "accounting_reports": '/main/accounting/reports',
    "analytics_artists": '/main/analytics/artists',
    "analytics_plugins": '/main/analytics/plugins',
    "contacts_import_export": '/main/contacts/import_export',
    "distribution_accounts": '/main/distribution/accounts',
    "distribution_orders": '/main/distribution/orders',
    "distribution_plugins": '/main/distribution/plugins',
    "distribution_reports": '/main/distribution/reports',
    "distribution_sales_imports": '/main/distribution/imports',
    "distribution_suppliers": '/main/distribution/suppliers',
    "distribution_shops": '/main/distribution/shops',
    "distribution_shop_groups": '/main/distribution/shop_groups',
    "distribution_supplier_orders": '/main/distribution/supplier_order',
    "distribution_statement_list": '/main/distribution/statement_list',
    "label_artists": '/main/catalog/catalog_artists',
    "label_labels": '/main/catalog/labels',
    "label_licensing": '/main/licencing/licences',
    "label_plugins": '/main/catalog/plugins',
    "label_products": '/main/catalog/products',
    "label_projects": '/main/catalog/projects',
    "label_statements": '/main/royalty/statements',
    "label_releases": '/main/catalog/releases',
    "label_royalty": '/main/royalty/royalty_accounts',
    "label_tracks": '/main/catalog/tracks',
    "label_catalog_product_groups": '/main/catalog/product_groups',
    "label_royalty_accounts": '/main/royalty/royalty_accounts',
    "label_royalty_contracts": '/main/royalty/contracts',
    "label_royalty_recoupable": '/main/royalty/recoupable',
    "label_royalty_checklist": '/main/royalty/checklist',
    "label_royalty_plugins": '/main/royalty/plugins',
    "label_licence_accounts": '/main/licencing/licence_accounts',
    "label_licensing_plugins": '/main/licencing/plugins',
    "management_artists": '/main/module/sub_menu',
    "management_plugins": '/main/module/sub_menu',
    "management_projects": '/main/module/sub_menu',
    "promotion_campaigns": '/main/module/sub_menu',
    "promotion_mailing_lists": '/main/module/sub_menu',
    "promotion_marketing": '/main/module/sub_menu',
    "promotion_plugins": '/main/module/sub_menu',
    "promotion_promotion_contacts": '/main/module/sub_menu',
    "promotion_results": '/main/module/sub_menu',
    "settings_accounting": '/main/settings/accounting',
    "settings_billing": '/main/settings/billing',
    "settings_booking": '/main/settings/booking',
    "settings_custom_texts": '/main/settings/custom_text',
    "settings_general": '/main/settings/general',
    "settings_identities": '/main/settings/identities',
    "settings_label": '/main/settings/label',
    "settings_language": '/main/settings/language',
    "settings_notices": '/main/settings/notices',
    "settings_promotion": '/main/settings/promotion',
    "settings_sharing": '/main/settings/sharing',
    "settings_user": '/main/settings/user',
  },
  "widgets": [],
  "tabs": {
    "accounting_costs_assign_projects": '/main/accounting/costs/$/assign_projects',
    "accounting_costs_overview": '/main/accounting/costs/$/overview',
    "accounting_costs_royalty_accounts": '/main/accounting/costs/$/royalty_accounts',
    "accounting_invoices_forwarding": '/main/accounting/invoices/$/forwarding',
    "accounting_invoices_invoice_lines": '/main/accounting/invoices/$/invoice_lines',
    "accounting_invoices_overview": '/main/accounting/invoices/$/overview',
    "accounting_invoices_payments": '/main/accounting/invoices/$/payments',
    "accounting_invoices_unlock": '/main/accounting/invoices/$/unlock',
    "accounting_reports_booking": '/main/accounting/reports/$/booking',
    "accounting_reports_invoice": '/main/accounting/reports/$/invoice',
    "booking_artists_additional_info": '/main/booking/artists/$/additional_info',
    "booking_artists_artist_app": '/main/booking/artists/$/artist_app',
    "booking_artists_artist_defaults": '/main/booking/artists/$/artist_defaults',
    "booking_artists_bookings": '/main/booking/artists/$/bookings',
    "booking_artists_ical_links": '/main/booking/artists/$/ical_links',
    "booking_artists_map": '/main/booking/artists/$/map',
    "booking_artists_other_defaults": '/main/booking/artists/$/other_defaults',
    "booking_artists_overview": '/main/booking/artists/$/overview',
    "booking_artists_playlist": '/main/booking/artists/$/playlist',
    "booking_calendar_documents": '/main/booking/calendar/$/documents',
    "booking_calendar_event_details": '/main/booking/calendar/$/event_details',
    "booking_calendar_local_details": '/main/booking/calendar/$/local_details',
    "booking_calendar_map": '/main/booking/calendar/$/map',
    "booking_calendar_money_details": '/main/booking/calendar/$/money_details',
    "booking_calendar_overview": '/main/booking/calendar/$/overview',
    "booking_calendar_travel_details": '/main/booking/calendar/$/travel_details',
    "booking_promoters_additional_info": '/main/booking/promoters/$/additional_info',
    "booking_promoters_bookings": '/main/booking/promoters/$/bookings',
    "booking_promoters_overview": '/main/booking/promoters/$/overview',
    "booking_templates_loop1": '/main/booking/templates/$/loop1',
    "booking_templates_loop2": '/main/booking/templates/$/loop2',
    "booking_templates_loop3": '/main/booking/templates/$/loop3',
    "booking_templates_loop4": '/main/booking/templates/$/loop4',
    "booking_templates_loop5": '/main/booking/templates/$/loop5',
    "booking_templates_loop6": '/main/booking/templates/$/loop6',
    "booking_templates_loop7": '/main/booking/templates/$/loop7',
    "booking_templates_loop8": '/main/booking/templates/$/loop8',
    "booking_templates_loop9": '/main/booking/templates/$/loop9',
    "booking_templates_overview": '/main/booking/templates/$/overview',
    "booking_templates_travel_loop": '/main/booking/templates/$/travel_loop',
    "booking_tours_actual": '/main/booking/tours/$/actual',
    "booking_tours_bookings": '/main/booking/tours/$/bookings',
    "booking_tours_costs_income": '/main/booking/tours/$/costs_income',
    "booking_tours_overview": '/main/booking/tours/$/overview',
    "booking_tours_tourbook": '/main/booking/tours/$/tourbook',
    "booking_tours_travel_schedule": '/main/booking/tours/$/travel_schedule',
    "booking_venues_additional_info": '/main/booking/venues/$/additional_info',
    "booking_venues_bookings": '/main/booking/venues/$/bookings',
    "booking_venues_overview": '/main/booking/venues/$/overview',
    "contacts_contacts_accounting": '/main/contacts/contact_list/$/accounting',
    "contacts_contacts_additional": '/main/contacts/contact_list/$/additional',
    "contacts_contacts_overview": '/main/contacts/contact_list/$/overview',
    "contacts_groups_overview": '/main/contacts/groups/$/overview',
    "distribution_accounts_catalogue": '/main/module/sub_menu/$/tab',
    "distribution_accounts_history": '/main/module/sub_menu/$/tab',
    "distribution_accounts_invoice_costs": '/main/module/sub_menu/$/tab',
    "distribution_accounts_orders": '/main/module/sub_menu/$/tab',
    "distribution_accounts_overview": '/main/module/sub_menu/$/tab',
    "distribution_accounts_setup": '/main/module/sub_menu/$/tab',
    "distribution_accounts_statements": '/main/module/sub_menu/$/tab',
    "distribution_digital_delivery_overview": '/main/module/sub_menu/$/tab',
    "distribution_orders_backorders": '/main/module/sub_menu/$/tab',
    "distribution_orders_orderlines": '/main/module/sub_menu/$/tab',
    "distribution_orders_overview": '/main/module/sub_menu/$/tab',
    "distribution_orders_packing_shipping": '/main/module/sub_menu/$/tab',
    "distribution_orders_summary": '/main/module/sub_menu/$/tab',
    "distribution_reports_release_report": '/main/module/sub_menu/$/tab',
    "distribution_reports_reports": '/main/module/sub_menu/$/tab',
    "distribution_imports_overview": '/main/module/sub_menu/$/tab',
    "distribution_imports_statement_list_costs": '/main/module/sub_menu/$/tab',
    "distribution_imports_statement_list_import_matching": '/main/module/sub_menu/$/tab',
    "distribution_imports_statement_list_import": '/main/module/sub_menu/$/tab',
    "distribution_imports_statement_list_sales_details": '/main/module/sub_menu/$/tab',
    "distribution_imports_statement_list_summary": '/main/module/sub_menu/$/tab',
    "distribution_imports_statement_list": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_list_catalogue": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_list_invoice_costs": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_list_orders": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_list_overview": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_list": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_orders_backorders": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_orders_overview": '/main/module/sub_menu/$/tab',
    "distribution_suppliers_orders": '/main/module/sub_menu/$/tab',
    "label_artists_bookings": '/main/module/sub_menu/$/tab',
    "label_artists_infos": '/main/module/sub_menu/$/tab',
    "label_artists_metadata": '/main/module/sub_menu/$/tab',
    "label_artists_overview": '/main/module/sub_menu/$/tab',

    // label -> label tabs
    "label_labels_overview": '/main/label/labels/$/overview',
    "label_labels_info": '/main/label/labels/$/info',
    "label_labels_releases_products": '/main/label/labels/$/release_products',
    "label_labels_setup": '/main/label/labels/$/setup',
    "label_labels_metadata": '/main/label/labels/$/metadata',

    "label_licensing_licence_accounts_invoices": '/main/module/sub_menu/$/tab',
    "label_licensing_licence_accounts_licences": '/main/module/sub_menu/$/tab',
    "label_licensing_licence_accounts_overview": '/main/module/sub_menu/$/tab',
    "label_licensing_licence_accounts": '/main/module/sub_menu/$/tab',
    "label_licensing_licences_income": '/main/module/sub_menu/$/tab',
    "label_licensing_licences_overview": '/main/module/sub_menu/$/tab',
    "label_licensing_licences_tracks": '/main/module/sub_menu/$/tab',
    "label_licensing_licences": '/main/module/sub_menu/$/tab',
    "label_products_costs": '/main/module/sub_menu/$/tab',
    "label_products_infos": '/main/module/sub_menu/$/tab',
    "label_products_metadata": '/main/module/sub_menu/$/tab',
    "label_products_overview": '/main/module/sub_menu/$/tab',
    "label_products_royalty": '/main/module/sub_menu/$/tab',
    "label_products_sales": '/main/module/sub_menu/$/tab',
    "label_products_specials": '/main/module/sub_menu/$/tab',
    "label_products_stock": '/main/module/sub_menu/$/tab',
    "label_products_tracks": '/main/module/sub_menu/$/tab',
    "label_projects_budget": '/main/module/sub_menu/$/tab',
    "label_projects_costs": '/main/module/sub_menu/$/tab',
    "label_projects_overview": '/main/module/sub_menu/$/tab',
    "label_projects_releases": '/main/module/sub_menu/$/tab',
    "label_projects_sales_planning_digi": '/main/module/sub_menu/$/tab',
    "label_projects_sales_planning_phy": '/main/module/sub_menu/$/tab',
    
    // label -> release tabs
    "label_releases_overview": '/main/label/releases/$/overview',
    "label_releases_infos": '/main/label/releases/$/infos',
    "label_releases_products": '/main/label/releases/$/products',
    "label_releases_costs": '/main/label/releases/$/costs',
    "label_releases_other_income":'/main/label/releases/$/other_income',
    "label_releases_sales": '/main/label/releases/$/sales',

    "label_royalty_accounts_balances": '/main/module/sub_menu/$/tab',
    "label_royalty_accounts_contracts": '/main/module/sub_menu/$/tab',
    "label_royalty_accounts_setup": '/main/module/sub_menu/$/tab',
    "label_royalty_accounts_statements": '/main/module/sub_menu/$/tab',
    "label_royalty_accounts": '/main/module/sub_menu/$/tab',
    "label_royalty_checklist": '/main/module/sub_menu/$/tab',
    "label_royalty_deals": '/main/module/sub_menu/$/tab',
    "label_royalty_recoupables": '/main/module/sub_menu/$/tab',
    "label_royalty_statements": '/main/module/sub_menu/$/tab',
    "label_tracks_metadata": '/main/module/sub_menu/$/tab',
    "label_tracks_overview": '/main/module/sub_menu/$/tab',
    "label_tracks_release_product_licensing": '/main/module/sub_menu/$/tab',
    "label_tracks_sales": '/main/module/sub_menu/$/tab',
    "management_artists_bookings": '/main/module/sub_menu/$/tab',
    "management_artists_invoices": '/main/module/sub_menu/$/tab',
    "management_artists_overview": '/main/module/sub_menu/$/tab',
    "management_artists_projects": '/main/module/sub_menu/$/tab',
    "management_projects_costs": '/main/module/sub_menu/$/tab',
    "management_projects_income": '/main/module/sub_menu/$/tab',
    "management_projects_overview": '/main/module/sub_menu/$/tab',
    "management_projects_report": '/main/module/sub_menu/$/tab',
    "promotion_campaigns_additional_info": '/main/module/sub_menu/$/tab',
    "promotion_campaigns_overview": '/main/module/sub_menu/$/tab',
    "promotion_campaigns_product_send_out": '/main/module/sub_menu/$/tab',
    "promotion_campaigns_results": '/main/module/sub_menu/$/tab',
    "promotion_campaigns_setup": '/main/module/sub_menu/$/tab',
    "promotion_mailing_lists_setup": '/main/module/sub_menu/$/tab',
    "promotion_marketing_additional_info": '/main/module/sub_menu/$/tab',
    "promotion_marketing_marketing_budget": '/main/module/sub_menu/$/tab',
    "promotion_marketing_marketing_costs": '/main/module/sub_menu/$/tab',
    "promotion_marketing_overview": '/main/module/sub_menu/$/tab',
    "promotion_promotion_contacts_campaigns": '/main/module/sub_menu/$/tab',
    "promotion_promotion_contacts_overview": '/main/module/sub_menu/$/tab',
    "promotion_promotion_contacts_setup_comments": '/main/module/sub_menu/$/tab',
  },
  "modules": {
    "booking": "/main/booking",
    "distribution": "/main/distribution",
    "management": "/main/management",
    "label": "/main/label",
    "catalog": "/main/catalog",
    "licencing": "/main/licencing",
    "royalty": "/main/royalty",
    "settings": "/main/settings",
    "accounting": "/main/accounting",
    "contacts": "/main/contacts",
    "analytics": "/main/analytics",
    "promotion": "/main/promotion"
  }
}

export const userPerm = {
  "modules": [
    "settings",
    "management",
    "promotion",
    "accounting"
  ],
  "tabs": [
    "accounting_invoices_overview",
    "management_artists_overview",
    "booking_artists_map",
    "distribution_suppliers_orders_backorders",
    "accounting_invoices_payments",
    "booking_artists_bookings",
    "accounting_invoices_forwarding",
    "booking_templates_loop7",
    "booking_templates_loop8",
    "management_projects_income",
    "promotion_campaigns_product_send_out",
    "management_artists_projects",
    "booking_artists_playlist",
    "accounting_invoices_unlock",
    "promotion_campaigns_setup",
    "booking_templates_overview",
    "distribution_suppliers_orders",
    "booking_templates_loop1",
    "promotion_promotion_contacts_setup_comments",
    "accounting_costs_overview",
    "booking_templates_loop3",
    "booking_artists_other_defaults",
    "management_artists_invoices",
    "distribution_suppliers_orders_overview",
    "distribution_suppliers_list_catalogue",
    "distribution_suppliers_list_invoice_costs",
    "booking_calendar_map",
    "management_projects_overview",
    "booking_templates_loop5",
    "accounting_reports_invoice",
    "accounting_costs_assign_projects",
    "distribution_suppliers_list",
    "promotion_campaigns_overview",
    "distribution_suppliers_list_orders",
    "booking_artists_overview",
    "promotion_campaigns_additional_info",
    "booking_templates_loop2",
    "accounting_invoices_invoice_lines",
    "booking_templates_loop6",
    "booking_artists_artist_defaults",
    "accounting_costs_royalty_accounts",
    "booking_templates_travel_loop",
    "booking_artists_additional_info",
    "booking_artists_artist_app",
    "promotion_campaigns_results",
    "management_projects_costs",
    "booking_templates_loop4",
    "booking_templates_loop9",
    "accounting_reports_booking",
    "booking_artists_ical_links",
    "promotion_promotion_contacts_overview",
    "promotion_mailing_lists_setup",
    "booking_promoters_overview",
    "promotion_promotion_contacts_campaigns",
    "distribution_suppliers_list_overview",
    "booking_venues_bookings",
    "management_artists_bookings",
    "management_projects_report"
  ],
  "sub_menu": [
    "accounting_reports",
    "settings_promotion",
    "accounting_invoices",
    "promotion_campaigns",
    "management_projects",
    "settings_language",
    "settings_custom_texts",
    "booking_artists",
    "management_plugins",
    "settings_notices",
    "settings_accounting",
    "settings_label",
    "promotion_promotion_contacts",
    "booking_templates",
    "promotion_mailing_lists",
    "settings_booking",
    "accounting_plugins",
    "management_artists",
    "accounting_costs",
    "settings_user",
    "accounting_invoice_reminder",
    "settings_billing",
    "settings_sharing",
    "settings_identities",
    "settings_general",
    "distribution_suppliers"
  ]
};


// console.log(testRoutePermission('http://localhost:8080/#/main/settings/users/130/overview'));
// console.log(testRoutePermission('http://localhost:8080/#/main/booking/artists'));
// console.log(testRoutePermission('http://localhost:8080/#/main/booking/calendar'));
// console.log(testRoutePermission('http://localhost:8080/#/main/booking/venues/12/bookings'));


// console.log(Object.keys(PermissionRouteMap.modules).length)
// console.log(Object.keys(PermissionRouteMap.sub_menu).length)
// console.log(Object.keys(PermissionRouteMap.tabs).length)
